import { FormatDate } from '../../../../utils/formatDate';
import MachineStatus from '../../machineStatus';
import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../../../Iconify';

const MachineReportListViewData = ({ fromMachinePage, report, handleReportClick, columnWidth }) => {
    if (!report) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.controle_date, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                {!fromMachinePage && <Box sx={{ color: '#414040', minWidth: columnWidth.machine }}><Skeleton variant="text" width="100%" /></Box>}
                <Box sx={{ color: '#414040', minWidth: columnWidth.verifier }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.accompanist }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.status }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.document }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row' onClick={() => handleReportClick(report)}>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.controle_date, maxWidth: columnWidth.controle_date, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography className='tableBodyTypography'>{FormatDate(report.control_date)}</Typography>
            </Box>
            {!fromMachinePage &&
                <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.machine, maxWidth: columnWidth.machine }}>
                    <Typography className='tableBodyTypography'>{report.machine?.name || 'N/A'}</Typography>
                </Box>
            }
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.verifier, maxWidth: columnWidth.verifier }}>
                <Typography className='tableBodyTypography'>{report.verifier.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.accompanist, maxWidth: columnWidth.accompanist }}>
                <Typography className='tableBodyTypography'>{report.accompanist.first_name} {report.accompanist.last_name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.status, maxWidth: columnWidth.status }}>
                <MachineStatus status={report?.status} />
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.document, maxWidth: columnWidth.document }}>
                <Typography className='tableBodyTypography'>{`${report.machine_control_document.length} PDFs`}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px', maxWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
        </Box>
    );
};

export default MachineReportListViewData;